import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "input", "text"]

  edit() {
    this.displayTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
    // The input target can be a wrapper <div> (the replacement variant editor), which has nothing to select
    if (this.inputTarget instanceof HTMLInputElement || this.inputTarget instanceof HTMLTextAreaElement) {
      this.inputTarget.select()
    }
  }

  save() {
    const newValue = this.inputTarget.value.trim()
    if (newValue && this.hasTextTarget) {
      this.textTarget.textContent = newValue
    }
    this.close()
  }

  cancel() {
    // Reset to original value
    if (this.hasTextTarget) {
      this.inputTarget.value = this.textTarget.textContent.trim()
    }
    this.close()
  }

  close() {
    this.inputTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }
}
